






















import Vue from 'vue'
import SplashScreen from '@/types/components/SplashScreen.interface'
import { mapGetters } from 'vuex'
export default Vue.extend({
    computed: {
        ...mapGetters(['tenant', 'xeroAccount', 'xeroConnection']),
        connectionColor(): string {
            return this.xeroConnection && this.xeroConnection.result
                ? 'primary--text'
                : 'red--text'
        },
        link(): string {
            const base = `${process.env.VUE_APP_URL_API}`
            return `${base}/xero/oauth/connect/redirect?tenant_id=${this.tenant.id}`
        }
    },
    methods: {
        toggleLoading(): void {
            //  Assemble a splash screen
            const splash: SplashScreen = { message: 'Connecting to Xero...' }

            //  Show the splash screen loader
            this.$store.commit('splashSet', splash)
        },
        xeroDisconnectConfirm(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Disconnect from Xero?',
                text: `Are you sure you want to disconnect from Xero?`,
                icon: 'mdi-alert-circle',
                color: 'yellow darken-2',
                callback: (result) => this.xeroDisconnect(result),
                admin: true
            })
        },
        async xeroDisconnect(result: boolean): Promise<void> {
            //  If the dialog result is false, do nothing
            if (!result) return

            //  Send disconnect request to API
            const response = await this.$store.dispatch('xeroDisconnect')

            //  If the request failed, do nothing
            if (!response) return

            //  Else, notify the user of success
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Disconnected from Xero',
                text: `You have been successfully disconnected from Xero.`,
                icon: 'mdi-link-variant-off',
                color: 'red darken-1'
            })
        }
    }
})
